module.exports = __webpack_public_path__ + "static/media/selfServeDot.3b700ed4.svg";